<template>
  <div>
    <b-modal
        :title="$t('Notifications')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="lg"
        no-close-on-backdrop lazy>
      <div class="mb-3">
        <button class="btn-trans-small mr-1" @click="selectAll"><img src="images/ico-check-double-solid-16.png"/>
          {{ $t("Select all") }}
        </button>
        <button class="btn-trans-small" @click="deleteNotification()"><img src="images/ico-trash-solid-16.png"/>
          {{ $t("Delete") }}
        </button>
      </div>
      <vue-custom-scrollbar class="list-notifications" @ps-y-reach-end="scroll">
        <b-card class="notification-item" v-for="(notification, index) in notifcations" :key="index" :data-read="notification.IsRead ? 'true' : 'false'" :data-selected="notification.IsSelected ? 'true' : 'false'">
            <div class="d-flex">
                <div class="notification-icon" @click="notification.IsSelected = notification.IsSelected ? false : true">
                  <b-icon :icon="notification.IsSelected ? 'check2' : 'chat-right-dots-fill'"></b-icon>
                </div>
              <div class="notification-content" @click="viewNotification(notification)">
                <div class="content">{{notification.Title}}</div>
                <div class="time">{{notification.Date}}</div>
              </div>
            </div>
        </b-card>
      </vue-custom-scrollbar>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
    <NotificationJIRequestModal ref="notificationJIRequestModal" @open="requestOpened"/>
  </div>
</template>

<script>
import notificationService from "../services/notification_service";
import dialogHelper from "../helpers/dialog_helper";
import NotificationJIRequestModal from "./NotificationJIRequestModal";

export default {
  name: "NotificationsModal",
  components: {NotificationJIRequestModal},
  data: function () {
    return {
      show: false,
      loading: false,
      ended: false,
      notifcations: []
    }
  },
  create() {
  },
  methods: {
    open() {
      this.show = true;
      this.reload();
    },
    reload() {
      this.ended = false;
      this.notifcations = [];
      this.loadNotifications();
    },
    async loadNotifications() {
      if (this.ended)
        return;

      this.loading = true;
      let totalNotifications = this.notifcations.length;
      let response = await notificationService.list(totalNotifications === 0 ? {} : {
        date: this.notifcations[totalNotifications-1].CreatedDate
      })
      this.loading = false;

      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      const notifications = JSON.parse(response.substr(3));
      this.ended = notifications.length < 50;

      notifications.forEach(x => {
        x.IsSelected = false;
        this.notifcations.push(x);
      });
    },
    scroll() {
      if (this.ended || this.loading)
        return;

      this.loadNotifications();
    },
    selectAll() {
      if (this.notifcations.find(x => x.IsSelected === false))
        this.notifcations.forEach(x => x.IsSelected = true);
      else
        this.notifcations.forEach(x => x.IsSelected = false);
    },
    async deleteNotification() {
      let ids = this.notifcations.filter(x => x.IsSelected).map(x => x.NotifyID);
      if (ids.length === 0) {
        dialogHelper.alert("Please select notification (s) to delete!", "warning");
        return;
      }

      let result = await dialogHelper.confirm("Are you sure to delete this notification (s)?")
      if (!result)
        return;

      this.loading = true;
      let response = await notificationService.deleteNotification(ids);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
      this.reload();
    },
    async viewNotification(notify) {
      if (notify.Data.startsWith("CustJIRequest:")) {
        this.$refs.notificationJIRequestModal.open(notify.NotifyID, notify.Data.replace("CustJIRequest:", ""))
      }
      else {
        this.loading = true;
        let response = await notificationService.read(notify.NotifyID);
        this.loading = false;
        if (!response)
          return;

        if (!response.startsWith("OK|")) {
          this.loading = false;
          dialogHelper.alert(response, "error");
          return;
        }

        notify.IsRead = true;
      }
    },
    requestOpened (idNotify, idRequest){
      let notify = this.notifcations.find(x => x.NotifyID == idNotify);
      if (notify != null)
        notify.IsRead = true;
    }
  }
}
</script>

<style scoped>
  .list-notifications {
    max-height: 400px;
  }


  .notification-item {
    background-color: rgba(255, 255, 255, 0.2);
    border: none;
    margin-bottom: 5px;
  }

  .notification-item[data-read="false"] {
    background-color: rgba(0, 0, 200, 0.2);
    font-weight: 600;
  }

  .notification-item:hover {
    background-color: rgba(255, 255, 255, 0.4);
    cursor: pointer;
  }

  .notification-item[data-read="false"]:hover  {
    background-color: rgba(0, 0, 200, 0.4);
  }

  .notification-item[data-selected="true"] {
    background-color: rgba(255, 255, 255, 0.6);
    font-weight: 600;
  }

  .notification-item[data-selected="true"][data-read="false"] {
    background-color: rgba(0, 0, 200, 0.6);
    font-weight: 600;
  }

  .notification-item .card-body {
    padding: 10px;
  }

  .notification-icon {
    display: block;
    height: 40px;
    width: 40px;
    line-height: 41px;
    background-color: #ffffff;
    border-radius: 50%;
    color: #39b54b;
    text-align: center;
    font-size: 20px;
    margin-right: 10px;
  }

  .notification-content {
    flex-direction: column;
    flex-basis: 0%;
    flex-grow: 1;
  }

  .notification-content .content {
    display: -webkit-box;
    width: 100%;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  .notification-content .time {
    font-size: 12px;
    line-height: 12px;
  }
</style>